import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    primary: {
      500: '#375078',
    },
    secondary: {
      500: '#A7C7E7',
    },
    accent: {
      500: '#FF9F29',
    },
    neutral: {
      white: '#FFFFFF',
      lightGray: '#F4F4F4',
      darkGray: '#4A4A4A',
      mediumGray: '#C1C1C1',
      regularGray: '#666666',
      softGray: '#9E9E9E',
    },
    text: {
      heading: '#4A4A4A',
      subheading: '#666666',
      body: '#333333',
      callout: '#FF9F29',
    },
  },
  fonts: {
    body: "'Inter', sans-serif",
    heading: "'Inter', sans-serif",
  },
});

export default theme;
